<div class="container">
  <div class="header-action-container">
    <button mat-raised-button color="primary" [routerLink]="['coupon/create']"
            [disabled]="!hasAuth()">新規登録
    </button>
  </div>

  <table mat-table [dataSource]="coupons" class="common-table mat-elevation-z8">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef> id</th>
      <td mat-cell *matCellDef="let coupon"> {{ coupon.id }}</td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef> タイトル</th>
      <td mat-cell *matCellDef="let coupon"> {{ coupon.title }}</td>
    </ng-container>

    <ng-container matColumnDef="expiredAt">
      <th mat-header-cell *matHeaderCellDef> 有効期限</th>
      <td mat-cell *matCellDef="let coupon"> {{ coupon.expiration_date | date: 'yyyy/MM/dd' }}</td>
    </ng-container>

    <ng-container matColumnDef="term">
      <th mat-header-cell *matHeaderCellDef> 配布期間</th>
      <td mat-cell *matCellDef="let coupon"> {{ coupon.beginning_distribution_term | date: 'yyyy/MM/dd' }}
        ~ {{ coupon.end_of_distribution_term | date: 'yyyy/MM/dd' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="condition">
      <th mat-header-cell *matHeaderCellDef> 配布条件</th>
      <td mat-cell *matCellDef="let coupon"> {{ getCondition(coupon) }}</td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let coupon; columns: displayedColumns;" [routerLink]="['coupon/edit/', coupon.id]"></tr>
  </table>
</div>
